/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Root_Recent_LabelInputs */

const en_explorer_root_recent_label = /** @type {(inputs: Explorer_Root_Recent_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent`)
};

const fr_explorer_root_recent_label = /** @type {(inputs: Explorer_Root_Recent_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recents`)
};

const de_explorer_root_recent_label = /** @type {(inputs: Explorer_Root_Recent_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jüngste`)
};

const it_explorer_root_recent_label = /** @type {(inputs: Explorer_Root_Recent_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recente`)
};

const ru_explorer_root_recent_label = /** @type {(inputs: Explorer_Root_Recent_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недавний`)
};

const es_explorer_root_recent_label = /** @type {(inputs: Explorer_Root_Recent_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reciente`)
};

const zh_cn2_explorer_root_recent_label = /** @type {(inputs: Explorer_Root_Recent_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近的`)
};

const ja_explorer_root_recent_label = /** @type {(inputs: Explorer_Root_Recent_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近の`)
};

const hi_explorer_root_recent_label = /** @type {(inputs: Explorer_Root_Recent_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाल ही का`)
};

const pt_pt2_explorer_root_recent_label = /** @type {(inputs: Explorer_Root_Recent_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recente`)
};

/**
* | output |
* | --- |
* | "Recent" |
*
* @param {Explorer_Root_Recent_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_root_recent_label = /** @type {((inputs?: Explorer_Root_Recent_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Root_Recent_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_root_recent_label(inputs)
	if (locale === "de") return de_explorer_root_recent_label(inputs)
	if (locale === "it") return it_explorer_root_recent_label(inputs)
	if (locale === "ru") return ru_explorer_root_recent_label(inputs)
	if (locale === "es") return es_explorer_root_recent_label(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_root_recent_label(inputs)
	if (locale === "ja") return ja_explorer_root_recent_label(inputs)
	if (locale === "hi") return hi_explorer_root_recent_label(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_root_recent_label(inputs)
	return en_explorer_root_recent_label(inputs)
});